import { trackError } from '#api/errors.ts';
import {
  LIFETIME_FOREVER_FLAG,
  LIFETIME_FOREVER_UNIT,
  type LIFETIME_UNITS,
} from './EndpointIdentityProviderForm.schema.ts';

export function convertToHours(units: (typeof LIFETIME_UNITS)[number], value: number | null) {
  if (!value) {
    return LIFETIME_FOREVER_FLAG;
  }
  switch (units) {
    case 'Hours':
      return value;
    case 'Days':
      return value * 24;
    case 'Weeks':
      return value * 24 * 7;
    case 'Months':
      return value * 24 * 30;
    case LIFETIME_FOREVER_UNIT:
      return LIFETIME_FOREVER_FLAG;
    default:
      trackError('Unknown unit when converting to hours');
      return 16;
  }
}
